import React from 'react'
import PropTypes from 'prop-types'
import WithWindowSize from 'Components/WithWindowSize'
import Spinner from 'Components/Spinner'
import { ARCHIVE_PAGINATION_LIMIT } from 'Defaults/searchPage'
import { getListingCount } from '../DisplayListingCount'
import { _ListingCountFloatingBar, _LeftButton, _ViewListingBtn } from './styles'

/**
 * This component shows listing counts and clear button
 * used in areas, filters view
 */
const ListingCountFloatingBar = (
  {
    onClickLeftButton,
    onClickListingCountButton,
    leftButtonLabel,
    pagination,
    dockIsOpen,
    isIE,
    isArchive,
    parentContainerRef,
    isLoading = false,
    haveComparedListings,
    mobileStyle,
    algoliaFeaturedTotal,
    offer,
    algoliaBuildingPagination,
  }) => {
  const isPrecon = offer === 'Precon'
  const parentContainerWidth = isIE && parentContainerRef && parentContainerRef.clientWidth
  const total = isPrecon ?
    algoliaBuildingPagination?.total :
    getListingCount({
      total: pagination ? (pagination.total + algoliaFeaturedTotal) : '',
      limit: ARCHIVE_PAGINATION_LIMIT - 1,
      enableLimit: isArchive,
    })
  return (
    <_ListingCountFloatingBar
      // IE 11 fix for the sticky
      style={{ width: parentContainerWidth || '100%' }}
      data-test-id={'listingCountFloatingBar'}
      sticky={!isIE && dockIsOpen}
      haveComparedListings={haveComparedListings}
      mobileStyle={mobileStyle}
    >
      {
        !mobileStyle ?
          <_LeftButton
            textClickableBtn
            onClick={onClickLeftButton}
          >
            {leftButtonLabel}
          </_LeftButton>
          : ''

      }
      <_ViewListingBtn
        data-test-id={'viewListingBtn'}
        primary
        medium
        onClick={onClickListingCountButton}
      >
        <span>
          {
            isLoading ? <Spinner /> : `View ${total} ${isPrecon ? 'Results' : 'Listings'}`
          }
        </span>
      </_ViewListingBtn>
    </_ListingCountFloatingBar>
  )
}

ListingCountFloatingBar.propTypes = {
  onClickLeftButton: PropTypes.func,
  onClickListingCountButton: PropTypes.func,
  leftButtonLabel: PropTypes.string,
  archivedPagination: PropTypes.shape({
    total: PropTypes.number,
  }),
  pagination: PropTypes.shape({
    total: PropTypes.number,
  }),
  dockIsOpen: PropTypes.bool,
  isIE: PropTypes.bool,
  parentContainerRef: PropTypes.shape({
    clientWidth: PropTypes.number,
  }),
  isLoading: PropTypes.bool,
  haveComparedListings: PropTypes.bool,
  isArchive: PropTypes.bool,
  mobileStyle: PropTypes.bool,
  algoliaFeaturedTotal: PropTypes.number,
  offer: PropTypes.string,
  algoliaBuildingPagination: PropTypes.shape({
    total: PropTypes.number,
  }),
}

export default WithWindowSize(ListingCountFloatingBar)
